import { Form, PillGroup } from '@homex/se-react-components';
import styled, { css } from 'styled-components/macro';

import { ReactComponent as InputErrorSvg } from 'components/svg/InputError.svg';
import { ReactComponent as LightBulbTipSvg } from 'components/svg/LightBulbTip.svg';
import { large } from 'styles/breakpoints';
import { container, containerTall } from 'styles/layout';
import { description, headingLower } from 'styles/typography';
import { IWithThemeProps } from 'typings';

interface IDescriptionProps {
  hasNotice: boolean;
}

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const Container = styled.div`
  ${container}

  margin-top: 25px;

  ${large`
    padding-right: 0;
  `}
`;

export const Buttons = styled.div`
  ${container}
`;

export const Subhead = styled.h2`
  ${headingLower}

  align-items: center;
  display: flex;
  margin: 0 0 3px;
  text-align: left;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

const noticeIconStyles = css`
  flex: 0 0 auto;
  height: 26px;
  width: 28px;
`;

export const NoticeIconError = styled(InputErrorSvg)`
  ${noticeIconStyles}
`;

export const NoticeIconTip = styled(LightBulbTipSvg)`
  ${noticeIconStyles}
`;

export const NoticeText = styled.span`
  padding-left: 9px;
`;

export const SecondaryQuestion = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  margin: 23px 0 0;
  padding: 17px 0 0;
`;

export const Description = styled.p<IDescriptionProps>`
  ${description}

  margin: 14px 0 0 37px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}

  ${({ hasNotice }) => {
    if (!hasNotice) {
      return `
        border-top: 1px solid rgba(0, 0, 0, 0.3);
        margin: 23px 0 0;
        padding: 19px 0 0;
      `;
    }

    return '';
  }}
`;

export const Warning = styled.p`
  ${description}

  align-items: flex-start;
  display: flex;
  font-style: italic;
  text-align: left;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const WarningIcon = styled(InputErrorSvg)`
  flex: 0 0 auto;
  height: 24px;
  width: 26px;
`;

export const WarningText = styled.span`
  padding: 2px 0 0 5px;
`;

export const PillGroupStyled = styled(PillGroup)`
  text-align: left;
`;
